//* The API hands the avatar back as a presigned S3 URL, but it stores and
//* expects the object key ("<userId>/<file>"). Sending the URL back saved a
//* link that expires, so the avatar stopped loading a while after an update.
export const getAvatarPath = (avatar?: string): string | undefined => {
  if (!avatar || !/^https?:\/\//i.test(avatar)) {
    return avatar;
  }

  try {
    const { pathname } = new URL(avatar);
    const segments = pathname
      .split("/")
      .filter(Boolean)
      .map((segment) => decodeURIComponent(segment));

    //* Everything before the last two segments belongs to the bucket or to the
    //* host style of the signed URL, never to the key.
    return segments.slice(-2).join("/") || avatar;
  } catch {
    return avatar;
  }
};
